import { Flex, FlexProps } from '@chakra-ui/react';

const MainContainer = ({ children, ...rest }: FlexProps) => (
  <Flex
    as="main"
    role="main"
    id="mainContainer"
    flex="1"
    minWidth={0}
    overflow="auto"
    width="100%"
    height="100%"
    {...rest}
  >
    {children}
  </Flex>
);

export default MainContainer;
